import moment from 'moment';
import React from 'react';
import {
  dateFormat,
  LedgerTransactionPaymentEnum,
  LedgerTransactionType,
} from '../../../../../utils/settings';
import { currencyNumber } from '../../SchemeBenefit/goldenAgePlanListing';

export default function LedgerTransaction({
  transactions = [],
  showOpeningBalance = true,
  // welspunCompany = false,
}) {
  return (
    <div
      style={{
        width: '100%',
        borderRadius: 5,
        overflow: 'hidden',
        marginTop: 30,
      }}
    >
      <div
        className='ledger_table-row'
        style={{
          backgroundColor: showOpeningBalance
            ? '#f1f5f9'
            : 'rgb(255, 255, 255)',
        }}
      >
        <h5 className='ledger_table-title'>Date</h5>
        <h5 className='ledger_table-title'>Payment ID</h5>
        <h5 className='ledger_table-title'>Status</h5>
        <h5
          className='ledger_table-title'
          style={{
            width: '100%',
            flex: 1,
            textAlign: 'right',
            marginRight: '2rem',
          }}
        >
          Amount
        </h5>
      </div>
      {showOpeningBalance && (
        <div
          className='ledger_table-row'
          style={{
            backgroundColor: 'rgb(255, 255, 255)',
          }}
        >
          {/* <div className="ledger_table-subTitle"> */}

          <h4
            style={{
              width: '100%',
              textAlign: 'center',
              flex: 1,
              // paddingLeft: 100,
            }}
          >
            {moment().startOf('month').format(dateFormat)}
            <br />
            Opening Balance
          </h4>
          {/* </div> */}

          <h5
            className='ledger_table-subTitle'
            style={{
              width: '100%',
              flex: 1,
              textAlign: 'center',
              // paddingRight: 100,
            }}
          >
            ₹ {Number(transactions.ledger_balance).toFixed(2)}{' '}
            <div
              style={{
                display: 'inline-block',
                fontSize: '12px',
                color: transactions.ledger_balance > 0 ? 'green' : 'red',
              }}
            >
              {transactions.ledger_balance > 0 ? 'Cr' : 'Dr'}
            </div>
          </h5>
        </div>
      )}
      {Array.isArray(transactions.ledger_transactions) &&
        transactions.ledger_transactions.length > 0 &&
        transactions.ledger_transactions.map((trans, index) => (
          <div
            className='ledger_table-row'
            style={{
              backgroundColor:
                index % 2 === 0 ? '#f1f5f9' : 'rgb(255, 255, 255)',
            }}
          >
            {/* Date  */}
            <div className='ledger_table-subTitle'>
              <h4
                style={{
                  width: '100%',
                  textAlign: 'center',
                  flex: 1,
                  // paddingLeft: 100,
                }}
              >
                {moment(trans.last_updated).format(dateFormat)}
              </h4>
            </div>

            {/* Payment ID*/}
            <div className='ledger_table-subTitle'>
              <h4
                style={{
                  width: '100%',
                  textAlign: 'center',
                  flex: 1,
                }}
              >
                {trans.invoice_no}
                {trans.payment_gateway_id}
              </h4>
            </div>

            {/* Payment Status*/}
            <div className='ledger_table-subTitle'>
              <h4
                style={{
                  width: '100%',
                  textAlign: 'center',
                  flex: 1,
                }}
              >
                {LedgerTransactionPaymentEnum[trans.status - 1].name}
              </h4>
            </div>

            {/* ---- Amount ---- */}
            <h5
              className='ledger_table-subTitle'
              style={{
                width: '100%',
                flex: 1,
                textAlign: 'right',
                marginRight: '2rem',
                color: LedgerTransactionPaymentEnum[trans.status - 1].color,
              }}
            >
              {currencyNumber(trans.amount)}
              <div
                style={{
                  display: 'inline-block',
                  fontSize: '12px',
                  marginLeft: '5px',
                  color:
                    trans.transaction_type === LedgerTransactionType['CREDIT']
                      ? 'green'
                      : 'red',
                }}
              >
                {trans.transaction_type === LedgerTransactionType['CREDIT']
                  ? 'Cr'
                  : 'Dr'}
              </div>
            </h5>
          </div>
        ))}
    </div>
  );
}
